import { Paper, Title, Switch, NumberInput, Stack, Button, Group, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useAutomationConfig, useUpdateAutomationConfig } from '@/hooks/useAutomation';
import { useEffect } from 'react';

export function RevenueThresholdConfig() {
  const { data: config, isLoading } = useAutomationConfig();
  const updateConfig = useUpdateAutomationConfig();

  const form = useForm({
    initialValues: {
      enabled: false,
      tokenCount: 10,
      thresholdAmount: 1000,
    },
  });

  useEffect(() => {
    if (config) {
      form.setValues({
        enabled: config.revenueThreshold.enabled,
        tokenCount: config.revenueThreshold.tokenCount,
        thresholdAmount: config.revenueThreshold.thresholdAmount,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  const handleSave = () => {
    if (!config) return;
    updateConfig.mutate(
      {
        ...config,
        revenueThreshold: {
          enabled: form.values.enabled,
          tokenCount: form.values.tokenCount,
          thresholdAmount: form.values.thresholdAmount,
          thresholdCurrency: 'EUR',
        },
      },
      {
        onSuccess: () => notifications.show({ message: 'Umsatz-Schwelle gespeichert.', color: 'green' }),
      },
    );
  };

  if (isLoading) return null;

  return (
    <Paper withBorder p="md" radius="md">
      <Stack gap="sm">
        <Title order={4}>Umsatz-Schwelle</Title>
        <Text size="sm" c="dimmed">
          Token werden automatisch versendet, wenn der Umsatz eines Unternehmens die
          eingestellte Schwelle überschreitet.
        </Text>

        <Switch
          label="Automatische Umsatz-Token aktiviert"
          checked={form.values.enabled}
          onChange={(e) => form.setFieldValue('enabled', e.currentTarget.checked)}
        />

        <Group grow>
          <NumberInput
            label="Umsatz-Schwelle (EUR)"
            min={1}
            disabled={!form.values.enabled}
            {...form.getInputProps('thresholdAmount')}
          />
          <NumberInput
            label="Anzahl Token"
            min={1}
            max={1000}
            disabled={!form.values.enabled}
            {...form.getInputProps('tokenCount')}
          />
        </Group>

        <Group justify="flex-end">
          <Button onClick={handleSave} loading={updateConfig.isPending}>
            Speichern
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
